import {handleApiError} from '@dms/shared';

import {type ApiError, useOnMount} from 'shared/web';

export type FinancingEndingQueryErrorReportProps = {
  error: ApiError;
  onReported?: () => void;
};

/**
 * Reports a failed query once, when the error first renders.
 */
export function FinancingEndingQueryErrorReport(props: FinancingEndingQueryErrorReportProps) {
  useOnMount(() => {
    handleApiError(props.error);
    props.onReported?.();
  });

  return null;
}
